import { stringToSearchPlayers } from "utils/helpers";
import { api } from "./api";
import { dedupedFetch, invalidateCache } from "./cache";

interface BuscarEntregasParams {
  player: string;
  start: string;
}

const getEntregasCacheKey = (params: BuscarEntregasParams) =>
  `entregas-${params.player}-${params.start}`;

export const invalidarCacheEntregas = (params: BuscarEntregasParams) => {
  invalidateCache(getEntregasCacheKey(params));
};

export const buscarEntregas = async (params: BuscarEntregasParams) => {
  return dedupedFetch(getEntregasCacheKey(params), async () => {
    const { data } = await api.post("find/entregas", params);
    return data;
  }, 30_000);
};

export const buscarEntregasPorGestor = async (params: BuscarEntregasParams) => {
  try {
    const { data } = await api.post("find/tasks_manager", params);
    return data;
  } catch (error) {
    console.error("Erro ao buscar entregas por gestor:", error);
    throw error;
  }
};

export async function findPlayer(search?: string) {
  let _search = search;

  if (typeof _search === "string") {
    _search = stringToSearchPlayers(_search);
  }

  try {
    const payload = {
      search: _search,
    };

    const { data } = await api.post(`find/players`, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export async function findManagers(
  search?: string,
  cod?: number[],
  all = false,
) {
  let _search = search;

  if (typeof _search === "string") {
    _search = stringToSearchPlayers(_search);
  }

  try {
    const payload = {
      search: _search,
    };

    const { data } = await api.post(`find/gestores`, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export const atualizarEntrega = async (params: any) => {
  try {
    const { data } = await api.put(`database/bb_task__c`, params);
    return data;
  } catch (error) {
    console.error("Erro ao atualizar entrega:", error);
    throw error;
  }
};
